import * as actionTypes from '../actionTypes';

const initialState = {
  lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'bg',
  animataionState: localStorage.getItem('animataionState') ? localStorage.getItem('animataionState') : 'on',
}

const commonReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.LANG_CHANGE:
      return {
        ...state,
        lang: action.lang
      }
    case actionTypes.ANIMATION_STATE_CHANGE:
      return {
        ...state,
        animataionState: action.animataionState
      }
  }

  return state;
}

export default commonReducer;